import { useGetUserSpecific3DsTx as useGetUserSpecific3DsTxQuery } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

/* Types */
type UseGetUserSpecific3DsTxProps = {
  cardId: number;
  tradeNo: string;
};

/* Hook */
export const useGetUserSpecific3DsTx = ({
  cardId,
  tradeNo,
}: UseGetUserSpecific3DsTxProps) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const { data, isLoading, isError, error } = useGetUserSpecific3DsTxQuery({
    enabled: !!id && !!cardId,
    userId: id ?? 0,
    cardId: cardId ?? 0,
    tradeNo: tradeNo ?? '0',
  });

  /* Return */
  return {
    isLoading,
    isError,
    error,
    record: data,
  };
};
